import { JointShape } from '@/modules/ConfiguratorJoints/composables/useShapeAndAngle';
import { JointCanvasTemplateConfiguration } from '@/modules/ConfiguratorJoints/types/canvasTemplate';
import {
    baseExternalCanvasTemplate,
    baseInternalCanvasTemplate,
} from '@/modules/ConfiguratorJoints/helpers/baseTemplateConfig';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const guideBottomUrl: string = require('@/modules/ConfiguratorJoints/assets/hero-5-alu-guide-bottom.png');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const guideTopUrl: string = require('@/modules/ConfiguratorJoints/assets/hero-5-alu-guide-top.png');

const heroFiveGuideDimensions = {
    bottom: { widthMm: 7.3240069, heightMm: 3.3707077, scale: 0.7 },
    top: { widthMm: 7.3564117, heightMm: 3.3856213, scale: 0.7 },
};

export const externalCanvasTemplate: JointCanvasTemplateConfiguration = {
    ...baseExternalCanvasTemplate,
    pivotGlobalConfiguration: {
        ...baseExternalCanvasTemplate.pivotGlobalConfiguration,
        regularGuideOneLeftArmX: -67,
        regularGuideOneLeftArmY: -39,
        regularGuideOneRightArmX: 38,
        regularGuideTwoRightArmY: 27,
    },
    guides: {
        ...baseExternalCanvasTemplate.guides!,
        leftBottom: {
            ...baseExternalCanvasTemplate.guides!.leftBottom!,
            ...heroFiveGuideDimensions.bottom,
            url: guideBottomUrl,
        },
        leftTop: {
            ...baseExternalCanvasTemplate.guides!.leftTop!,
            ...heroFiveGuideDimensions.top,
            url: guideTopUrl,
        },
        rightBottom: {
            ...baseExternalCanvasTemplate.guides!.rightBottom!,
            ...heroFiveGuideDimensions.bottom,
            url: guideBottomUrl,
        },
        rightTop: {
            ...baseExternalCanvasTemplate.guides!.rightTop!,
            ...heroFiveGuideDimensions.top,
            url: guideTopUrl,
        },
    },
};

export const internalCanvasTemplate: JointCanvasTemplateConfiguration = {
    ...baseInternalCanvasTemplate,
    pivotGlobalConfiguration: {
        ...baseInternalCanvasTemplate.pivotGlobalConfiguration,
        regularGuideOneLeftArmX: -40,
        regularGuideOneLeftArmY: -10,
        regularGuideOneRightArmY: 41,
    },
    guides: {
        ...baseInternalCanvasTemplate.guides!,
        leftBottom: {
            ...baseInternalCanvasTemplate.guides!.leftBottom!,
            ...heroFiveGuideDimensions.bottom,
            url: guideBottomUrl,
        },
        leftTop: {
            ...baseInternalCanvasTemplate.guides!.leftTop!,
            ...heroFiveGuideDimensions.top,
            url: guideTopUrl,
        },
        rightBottom: {
            ...baseInternalCanvasTemplate.guides!.rightBottom!,
            ...heroFiveGuideDimensions.bottom,
            url: guideBottomUrl,
        },
        rightTop: {
            ...baseInternalCanvasTemplate.guides!.rightTop!,
            ...heroFiveGuideDimensions.top,
            url: guideTopUrl,
        },
    },
};

export const heroFiveJointCanvasTemplate: Record<JointShape, JointCanvasTemplateConfiguration> = {
    external: externalCanvasTemplate,
    internal: internalCanvasTemplate,
};
